import { render, staticRenderFns } from "./clienteditapi.vue?vue&type=template&id=deddc2aa"
import script from "./clienteditapi.vue?vue&type=script&lang=js"
export * from "./clienteditapi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports